export type LanguagePreference = "auto" | "en" | "fr";
export const languageStorageKey = "pentaadmin.language";

export function detectBrowserLanguage(
  languages: readonly string[],
): "en" | "fr" {
  for (const language of languages) {
    const base = language.toLowerCase().split(/[-_]/)[0];
    if (base === "en" || base === "fr") return base;
  }
  return "en";
}

export function readLanguagePreference(): LanguagePreference {
  try {
    const saved = localStorage.getItem(languageStorageKey);
    if (saved === "en" || saved === "fr") return saved;
  } catch {
    // Browser language still works when storage is disabled.
  }
  return "auto";
}
